
import imgChange from "./index.js";
import { Uploader, Toast } from "vant";
Vue.use(Uploader);
import { Component, Vue } from "vue-property-decorator";
import { opinionConfig, feedBack, imageUpload } from "@/req/user";
import updateImg from "./components/updateImg.vue";
import NavBar from "@/components/navBar.vue";
@Component({
  components: {
    updateImg,
    NavBar,
  },
})
export default class Logout extends Vue {
  public imgUrl = "";
  public isShowPhptoPopup = false;
  public btnId = 0;
  public feedBackConent = "";
  public phone = "";
  public btnBgc = false;
  public data: any = [];
  public dataImg: any = [];
  public dataBtn: any = [];
  public imgList: any = [];
  public fileList: any = [];
  public url = this.$HTTP_API.user.imageUpload;
  public mounted() {
    this.getOpinionConfig();
  }

  public afterRead(file) {
    const num = this.dataImg.length + (file.length ? file.length : 1);
    const fileList: any = [];
    if (num > 9) {
      this.$dialog.alert({
        message: "最多支持9张图片",
        confirmButtonText: "取消",
        confirmButtonColor: "#000",
      });
      return;
    }
    if (!file.length) {
      file = fileList.push(file);
      this.upDateFile(fileList);
    } else {
      this.upDateFile(file);
    }
  }

  public upDateFile(file) {
    file.forEach(async (itme) => {
      const obj = {
        module: "img",
        base64: itme.content,
      };
      const res = await imgChange(this.url, obj);
      const arr: any = {
        name: res.data.info.domian,
        urls: res.data.info.domian + "/" + res.data.info.url,
        url: res.data.info.url,
      };
      this.imgList.push(arr);
      this.imgUrl = window.URL.createObjectURL(itme.file);
      this.dataImg.push(this.imgUrl);
    });
  }

  public onOversize(file) {
    Toast("文件大小不能超过 2048kb");
  }
  public beforeRead(file) {
    let arr: any = [];
    if (!file.length) {
      arr.push(file);
    } else {
      arr = file;
    }
    arr.forEach((itme) => {
      const imgType = "image/jpeg,image/jpg,image/png".includes(itme.type);
      if (!imgType) {
        const fileType = itme.type.split("/");
        Toast(`暂不支持上传${fileType[1]}格式的图片`);
        return false;
      }
    });
    return true;
  }
  public async getOpinionConfig() {
    const res = await opinionConfig();
    this.dataBtn = res.data;
  }
  public async onSumbit() {
    this.feedBackConent.trim();
    if (this.btnId == 0) return this.hintMessage("请选择问题类型");
    if (this.feedBackConent.split(" ").join("").length == 0)
      return this.hintMessage("请输入问题描述");
    if (this.feedBackConent.length < 30)
      return this.hintMessage("问题描述不得低于30个字");
    const list: any = [];
    for (let i = 0; i < this.imgList.length; i++) {
      list[i] = this.imgList[i].url;
    }
    const obj = {
      token: this.$fn.cookies.getToken(),
      type: this.btnId,
      content: this.feedBackConent,
      image: list,
      phone: this.phone,
    };
    const res = await feedBack(obj);
    if (res.code === 200) {
      this.$dialog
        .alert({
          message: "提交反馈成功，谢谢您的反馈",
          confirmButtonColor: "#000",
        })
        .then(() => {
          this.$router.go(-1);
        });
    } else {
      this.hintMessage(res.msg);
    }
  }

  public hintMessage(val) {
    this.$dialog.alert({
      message: val,
      confirmButtonColor: "#000",
    });
  }

  public onBtn(id) {
    this.btnId = id;
  }

  public deleteImg(i) {
    this.data = {
      imgUrl: this.dataImg[i],
      id: i,
    };
    this.isShowPhptoPopup = true;
  }

  public confirmDelImg(event) {
    if (event || event === 0) {
      this.dataImg.splice(event, 1);
      this.imgList.splice(event, 1);
    }
    this.isShowPhptoPopup = false;
  }
}
